import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AppContext } from '../../../context/AppContext';
import "../../../assets/css/doctor/docbuttons/DoctorProfile.css";

const DoctorProfile = ({ doctor, onClose, onBookAppointment }) => {
  const { baseUrl } = useContext(AppContext);

  // `doctor` prop se jo bhi mila (list se aaya partial data) usko turant
  // dikhate hain, aur background mein `/doctors/{id}` se poori detail
  // (bio, address, education, specialization, etc — jo doctor ne apne
  // ProfileManagement form se save ki thi) fetch kar ke merge kar dete hain.
  const [fullDoctor, setFullDoctor] = useState(doctor);

  useEffect(() => {
    if (!doctor?.id) return;

    axios
      .get(`${baseUrl}/doctors/${doctor.id}`)
      .then((res) => {
        setFullDoctor((prev) => ({ ...prev, ...res.data }));
      })
      .catch((err) => {
        console.error('Doctor detail load error:', err);
      });
  }, [doctor?.id, baseUrl]);

  const d = fullDoctor || {};

  // ── Helpers ───────────────────────────────────────────────────
  const formatExperience = (exp) => {
    if (!exp) return '—';
    const str = String(exp);
    return /year/i.test(str) ? str : `${str} years`;
  };

  const availabilityShort = (val) => {
    if (val === 'Available Today') return 'Today';
    if (val === 'Available Tomorrow') return 'Tomorrow';
    if (val === 'Not Available') return 'Unavailable';
    return val || '—';
  };

  const isOpenDay = d.available !== 'Not Available';
  const schedule = [
    { day: 'Monday',    time: '09:00 AM - 05:00 PM', available: isOpenDay },
    { day: 'Tuesday',   time: '09:00 AM - 05:00 PM', available: isOpenDay },
    { day: 'Wednesday', time: '09:00 AM - 05:00 PM', available: isOpenDay },
    { day: 'Thursday',  time: '09:00 AM - 05:00 PM', available: isOpenDay },
    { day: 'Friday',    time: '09:00 AM - 02:00 PM', available: isOpenDay },
    { day: 'Saturday',  time: 'Closed',               available: false },
    { day: 'Sunday',    time: 'Closed',               available: false }
  ];

  const stats = [
    { cls: 'exp', value: formatExperience(d.experience), label: 'Experience', icon: '🏆' },
    { cls: 'rat', value: `${d.rating ?? '—'} ⭐`, label: `${d.reviews ?? 0} Reviews`, icon: '⭐' },
    { cls: 'pat', value: availabilityShort(d.available), label: 'Availability', icon: '🗓️' },
    { cls: 'fee', value: d.fee ? `Rs. ${Number(d.fee).toLocaleString()}` : '—', label: 'Consultation Fee', icon: '💰' }
  ];

  return (
    <div className="dp-overlay" onClick={onClose}>
      <div className="dp-container" onClick={e => e.stopPropagation()}>

        {/* ── Sirf close button sticky — zero-height wrapper so it doesn't push layout down ── */}
        <div style={{ position: 'sticky', top: 0, height: 0, zIndex: 200 }}>
          <button className="dp-close-btn" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="18" y1="6"  x2="6"  y2="18"/>
              <line x1="6"  y1="6"  x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* ── Header — normal (sticky nahi), sath hi scroll hoga ── */}
        <div className="dp-header">
          <div className="dp-banner"></div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '-60px', paddingBottom: '1rem' }}>
            <div className="dp-img-wrap">
              <img
                src={d.profile_image_url || d.image || `https://ui-avatars.com/api/?name=${encodeURIComponent(d.name || 'Doctor')}&size=150&background=FF6F00&color=fff&bold=true`}
                alt={d.name}
                className="dp-doctor-img"
              />
              <div className="dp-verified-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* ── Sab kuch is ke neeche normal scroll karta hai — sab dynamic (DB se) ── */}
        <div className="dp-content" style={{ paddingTop: '0.5rem' }}>

          {/* NAME + SPECIALIZATION + STATS + ACTION — center-aligned */}
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h3 style={{ fontSize: '2rem', fontWeight: 800, color: '#FF8C00', marginBottom: '0.4rem' }}>
              {d.name || 'Doctor'}
            </h3>
            <p style={{ fontSize: '1.1rem', color: '#00005a', fontWeight: 700, marginBottom: '1.5rem' }}>
              {d.specialization || 'Specialization not set'}
            </p>

            <div className="dp-stats-grid" style={{ marginBottom: '1.5rem' }}>
              {stats.map(({ cls, value, label, icon }) => (
                <div key={cls} className="dp-stat-box">
                  <div className={`dp-stat-icon ${cls}`}>{icon}</div>
                  <div>
                    <span className="dp-stat-value">{value}</span>
                    <span className="dp-stat-label">{label}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="dp-actions" style={{ maxWidth: '340px', margin: '0 auto' }}>
              <button className="dp-btn-book" onClick={onBookAppointment}>Book Appointment</button>
            </div>
          </div>

          {/* ABOUT — d.bio (ProfileManagement form ke "Professional Bio" field se) */}
          <div className="dp-section">
            <h2 className="dp-section-title">About Doctor</h2>
            <p className="dp-about-text">
              {d.bio
                ? d.bio
                : `Dr. ${d.name || ''} is a ${d.specialization || 'mental health professional'} with over ${d.experience || '0'} years of experience.`}
            </p>
          </div>

          {/* LOCATION — d.location + d.address (form se) */}
          <div className="dp-section">
            <h2 className="dp-section-title">Location</h2>
            <div className="dp-location-card">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <div className="dp-location-info">
                <h4>{d.location || 'Not set'}</h4>
                <p>{d.address || 'Address not provided'}</p>
              </div>
            </div>
          </div>

          {/* EDUCATION — d.education + d.specialization (form se) */}
          <div className="dp-section">
            <h2 className="dp-section-title">Education</h2>
            <div className="dp-timeline">
              <div className="dp-timeline-item">
                <div className="dp-timeline-dot"></div>
                <div className="dp-timeline-content">
                  <h3>{d.education || 'Not provided'}</h3>
                  <p className="dp-institution">{d.specialization || 'Specialization not set'}</p>
                </div>
              </div>
            </div>
          </div>

          {/* SCHEDULE — real "available" status ke mutabiq */}
          <div className="dp-section">
            <h2 className="dp-section-title">Weekly Schedule</h2>
            <div className="dp-schedule-list">
              {schedule.map((day, i) => (
                <div key={i} className={`dp-schedule-item ${!day.available ? 'dp-closed' : ''}`}>
                  <span className="dp-schedule-day">{day.day}</span>
                  <span className="dp-schedule-time">{day.time}</span>
                  <span className={`dp-schedule-status ${day.available ? 'dp-available' : 'dp-unavailable'}`}>
                    {day.available ? 'Available' : 'Closed'}
                  </span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DoctorProfile;